import { PublishedModule } from '../modules/published';

export function PublishedPrototype() {
  return <PublishedModule kind="prototype" />;
}

export default PublishedPrototype;
